/*
 * Scott & Jamie — wishlist (no app needed)
 * - Hearts ([data-sj-wish="<product-handle>"]) save/remove the product in this browser (localStorage).
 * - Header heart shows the number of saved products ([data-sj-wishlist-count]).
 * - Wishlist page ([data-sj-wishlist-grid]) renders the saved products via /products/<handle>?view=sj-wishlist-card.
 * Saved items stay on this device/browser; they are not linked to a customer account.
 */
(() => {
  if (window.sjWishlist) return;
  const KEY = 'sj-wishlist';

  const read = () => {
    try {
      const list = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(list) ? list.filter((h) => typeof h === 'string') : [];
    } catch { return []; }
  };
  const write = (list) => {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch { /* storage blocked: keep working for this page */ }
    memory = list;
  };
  let memory = read();
  const list = () => memory;
  const has = (handle) => list().includes(handle);

  function toast(message) {
    const el = document.querySelector('[data-sj-toast]');
    if (!el) return;
    el.textContent = message;
    el.classList.add('is-on');
    clearTimeout(toast.t);
    toast.t = setTimeout(() => el.classList.remove('is-on'), 2400);
  }

  function sync() {
    const items = list();
    document.querySelectorAll('[data-sj-wish]').forEach((btn) => {
      const on = items.includes(btn.dataset.sjWish);
      if (btn.getAttribute('aria-pressed') !== String(on)) btn.setAttribute('aria-pressed', String(on));
      const label = btn.querySelector('[data-sj-wish-label]');
      if (label) label.textContent = on ? btn.dataset.labelSaved || 'Saved to wishlist' : btn.dataset.labelAdd || 'Add to wishlist';
    });
    document.querySelectorAll('[data-sj-wishlist-count]').forEach((el) => {
      el.textContent = items.length;
      el.hidden = items.length === 0;
    });
    document.querySelectorAll('[data-sj-wishlist-link]').forEach((el) => {
      el.setAttribute('aria-label', items.length ? `Wishlist (${items.length} saved)` : 'Wishlist');
    });
  }

  function toggle(handle) {
    const items = list().slice();
    const i = items.indexOf(handle);
    if (i === -1) { items.unshift(handle); write(items); toast('Saved to your wishlist'); }
    else { items.splice(i, 1); write(items); toast('Removed from your wishlist'); }
    sync();
    document.dispatchEvent(new CustomEvent('sj:wishlist:change', { detail: { items } }));
  }

  // Hearts can sit inside a product-card link: stop the link from opening.
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-sj-wish]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    toggle(btn.dataset.sjWish);
  }, true);

  // Other tabs
  window.addEventListener('storage', (e) => { if (e.key === KEY) { memory = read(); sync(); renderPage(); } });

  // Horizon re-renders cards (filters, recommendations): keep new hearts in sync.
  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; sync(); });
  }).observe(document.documentElement, { childList: true, subtree: true });

  // ---------- Wishlist page ----------
  async function renderPage() {
    const grid = document.querySelector('[data-sj-wishlist-grid]');
    if (!grid) return;
    const empty = document.querySelector('[data-sj-wishlist-empty]');
    const countEl = document.querySelector('[data-sj-wishlist-page-count]');
    const items = list();
    if (countEl) countEl.textContent = `${items.length} ${items.length === 1 ? 'item' : 'items'}`;
    if (!items.length) {
      grid.innerHTML = '';
      grid.hidden = true;
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;
    grid.hidden = false;
    grid.setAttribute('aria-busy', 'true');
    const missing = [];
    const cards = await Promise.all(items.map(async (handle) => {
      try {
        const res = await fetch(`/products/${encodeURIComponent(handle)}?view=sj-wishlist-card`, { credentials: 'same-origin' });
        if (res.status === 404) { missing.push(handle); return ''; }
        if (!res.ok) return '';
        return await res.text();
      } catch { return ''; }
    }));
    // Products that no longer exist are removed from the list.
    if (missing.length) write(list().filter((h) => !missing.includes(h)));
    grid.innerHTML = cards.join('');
    grid.removeAttribute('aria-busy');
    if (countEl) { const n = list().length; countEl.textContent = `${n} ${n === 1 ? 'item' : 'items'}`; }
    if (!list().length) { grid.hidden = true; if (empty) empty.hidden = false; }
    sync();
  }
  document.addEventListener('sj:wishlist:change', () => {
    // On the wishlist page a removed item disappears right away
    if (document.querySelector('[data-sj-wishlist-grid]')) renderPage();
  });

  window.sjWishlist = { list, has, toggle };
  const start = () => {
    // The toast is rendered in the header, which creates its own positioning context: move it to <body>
    // so it appears at the bottom of the screen.
    const t = document.querySelector('[data-sj-toast]');
    if (t && t.parentElement !== document.body) document.body.append(t);
    sync();
    renderPage();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
